module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/157.1b2bf05b.png";